export default __webpack_public_path__ + "static/media/modal-cross.151fe729.svg";